import gql from 'graphql-tag';

export const FLOATING_RATES_FRAGMENT = gql`
  fragment FloatingRatesInfo on FloatingRates {
    id
    firstInsurance
    secondInsurance
    thirdInsurance
    firstInstallment
    secondInstallment
    thirdInstallment
    fourthInstallment
    vat
    specificOldTax
    otherOldTax
    newTax
    realEstateSecurity
    honoraires
  }
`;

export const MANDATARY_RATE_FRAGMENT = gql`
  fragment MandataryRate on MandataryRate {
    year
    exellentRate
    teg
    goodRate
  }
`;
